<template>
     <LoadingIndicator v-if="loading && !error" message="Loading Dashboard"/>
     <SystemMessage v-if="!loading && error" message="Unable to load the dashboard. Please try refreshing the page"/>
       <div v-if="!loading && !error" class="dashboard">
          <div class="theme-card users-card">
               <div class="stat-info">
                    <div class="stat-title">Users</div>
                    <div class="stat-content">{{formatTotal(stats.totalUsers)}}</div>
               </div>
               <div class="stat-info">
                    <div class="stat-title">Businesses</div>
                    <div class="stat-content">{{formatTotal(stats.totalEmployers)}}</div>
               </div>
                <div class="stat-info">
                    <div class="stat-title">Job Seekers</div>
                    <div class="stat-content">{{formatTotal(stats.totalJobSeekers)}}</div>
               </div>
               <div class="activity">
                    <div title="Activated
                     Users" class="active">
                         <ZapIcon class="zap"/> <div class="total">{{formatTotal(stats.totalActiveUsers)}}</div>
                    </div>
                     <div title="Deactivated Users" class="inactive" style="color:var(--orange)!important; margin-right:0.7rem;">
                         <ZapOffIcon class="zap"/> <div class="total">{{formatTotal(stats.totalInactiveUsers)}}</div>
                    </div>
                     <div title="Suspended Users" class="inactive">
                         <SlashIcon class="zap"/> <div class="total">{{formatTotal(stats.totalSuspendedUsers)}}</div>
                    </div>
               </div>
          </div>
          <div class="theme-card vacancies-card">
                <div class="stat-info">
                    <div class="stat-title">Vacancies</div>
                    <div class="stat-content">{{formatTotal(stats.totalVacancies)}}</div>
               </div>
               <div class="stat-info">
                    <div class="stat-title">Applications</div>
                    <div class="stat-content">{{formatTotal(stats.totalJobApplications)}}</div>
               </div>
                
               
          </div>

       </div>
</template>
<script>
import ZapIcon from '@/components/IconComponents/ZapIcon.vue';
import ZapOffIcon from '@/components/IconComponents/ZapOffIcon.vue';
import SlashIcon from '@/components/IconComponents/SlashIcon.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import { getDashboardStatisticsAsync } from '@/services/admin/adminService';
export default {
    components:{
      ZapIcon, ZapOffIcon, SlashIcon, LoadingIndicator, SystemMessage
    },
    data(){
     return{
          loading: true,
          error: false,
          stats: {}
     }
    },
    async mounted(){
     await this.loadDashboard();
    },
    methods:{
     formatTotal(total){
          return new Intl.NumberFormat('en-US').format(total);
     },
     async loadDashboard(){
          try{
               this.loading = true;
               this.error = false;
               let response = await getDashboardStatisticsAsync();
               if(!response.success){
                    let err = new Error();
                    throw err;
               }else{
                    this.stats = response.stats;
                    this.loading = false;
                    this.error = false;
               }
          }catch(e){
               this.loading = false;
               this.error = true;
          }
     }
    }
}
</script>
<style scoped>

     .activity{
          display: flex;
     }

     .zap{
          height:0.9rem;
          margin-top:0.1rem;
     }

     .active, .inactive{
          display: flex;
          align-items:center;
     }

     .stat-info{
          margin-bottom:1rem;
          
     }

     .stat-content{
          margin-top:-0.6rem;
          font-size:2.4rem;
          font-family: var(--numbers);
     }

     .stat-title{
          color:var(--page-header);
          font-family: var(--heading-font2-regular);
          font-size:1.2rem;
     }

      .active{
          margin-right:0.7rem;
          color:var(--green);
      }

      .inactive{
          color:var(--red);
      }

      

    .dashboard{
     display: grid;
     grid-template-columns: 1fr 1fr;
     
    }

    .activity{
     align-self: end;
    }

    
    .users-card{
     grid-template-rows:auto auto auto 1fr;
    }

    .vacancies-card{
     grid-template-rows:auto auto auto 1fr;
    }

    .theme-card{
     padding:1rem 1.1rem;
     display:grid;
     border-radius:25px;
     min-height:23rem!important;
      background: url('../../assets/images/blurs.png') no-repeat right/100%, var(--intro-background);
    }
</style>